import { handleActions } from 'redux-actions'

import { ACTUAL_CONTENTS_DEFAULT_DASHBOARD_ID } from '../services/dashboards'
import {
  createDashboard,
  deleteDashboard,
  getTenantContentsDashboards,
  resetDefaultDashboard,
  resetState,
  selectTenantContentsDashboard,
  setDashboardAsDefault,
  setDashboardPublished,
  updateDashboard,
} from '../actions'

const defaultState = {
  list: [],
  selectedDashboardId: ACTUAL_CONTENTS_DEFAULT_DASHBOARD_ID,
}

export default handleActions(
  {
    [getTenantContentsDashboards.success](state, action) {
      return { ...state, list: action.response.data }
    },
    [createDashboard.success](state, action) {
      return { ...state, list: [...state.list, action.response.data] }
    },
    [selectTenantContentsDashboard](state, action) {
      return { ...state, selectedDashboardId: action.payload.selectedDashboard.Id }
    },
    [setDashboardAsDefault.success](state, action) {
      const dashboardId = action.payload
      const updatedList = state.list.map((dashboard) =>
        dashboard.Id === dashboardId ? { ...dashboard, IsDefault: true } : { ...dashboard, IsDefault: false }
      )

      return { ...state, list: updatedList }
    },
    [resetDefaultDashboard.success](state, action) {
      const updatedList = state.list.map((dashboard) =>
        dashboard.IsDefault ? { ...dashboard, IsDefault: false } : dashboard
      )

      return { ...state, list: updatedList }
    },
    [deleteDashboard.success](state, action) {
      const dashboardId = action.payload
      const updatedList = state.list.filter((dashboard) => dashboard.Id !== dashboardId)
      const defaultDashboardId = updatedList.find((v) => v.IsDefault)?.Id || ACTUAL_CONTENTS_DEFAULT_DASHBOARD_ID

      return { ...state, list: updatedList, selectedDashboardId: defaultDashboardId }
    },
    [updateDashboard.success](state, action) {
      const { Id, Name, Columns } = action.response.data
      const updatedList = state.list.map((dashboard) =>
        dashboard.Id === Id ? { ...dashboard, Name, Columns } : dashboard
      )

      return { ...state, list: updatedList }
    },
    [setDashboardPublished](state, action) {
      const { Id, IsPublished } = action.payload
      const updatedList = state.list.map((dashboard) =>
        dashboard.Id === Id ? { ...dashboard, IsPublished } : dashboard
      )

      return { ...state, list: updatedList }
    },
    [resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
